import { RxCross2 } from "react-icons/rx";
import React, { useEffect, useState } from "react";
import { Dropdown, DropdownToggle, Form } from "react-bootstrap";
import { IoPersonAddOutline, IoWarningOutline } from "react-icons/io5";
import { GoFile, GoPerson } from "react-icons/go";
import { Spinner } from "../../common/Helper";
import { CiWavePulse1 } from "react-icons/ci";
import { getFiltersOptionsData } from "../../api/Service";
import "./FilterModal.css"; 
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";

const FilterModal = ({ handleChangeInFilters, filterOptions, setFilterOptions }) => {
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isDropDownOptionsLoading, setIsDropDownOptionsLoading] = useState(false);
  const [hasMoreOptions, setHasMoreOptions] = useState(true);
  const [hasMany, setHasMany] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [hasManyCaseMixSpeciality, setHasManyCaseMixSpeciality] = useState(false);
  const [caseMixSpecialityList, setCaseMixSpecialityList] = useState([]);
  const [selectedCaseMixSpecialityList, setSelectedCaseMixSpecialityList] = useState([]);
  const [codedByList, setcodedByList] = useState([]);
  const [insurerIdentifierList, setInsurerIdentifierList] = useState([]);
  const [selectedInsurerIdentifierList, setSelectedInsurerIdentifierList] = useState([]);
  const [selectedCodedByList, setSelectedCodedByList] = useState([]);
  const [priorityValues,setPriorityValues] = useState([1,2,3,4,5])
  const [selectedPriorityValues,setSelectedPriorityValues] = useState([])
  const [lengthOfStayInput, setLengthOfStayInput] = useState("");
  const [dropDownOptions, setDropDownOptions] = useState({
    caseMixSpeciality: [],
    insurerIdentifier: [],
    codedBy: [],
    priorityValue: [1, 2, 3, 4, 5],
  });

  // Case Mix Speciality handlers
  const handleCaseMixItemClick = (option, e) => {
    e.stopPropagation();
    const updated = selectedCaseMixSpecialityList.includes(option)
      ? selectedCaseMixSpecialityList.filter(item => item !== option)
      : [...selectedCaseMixSpecialityList, option];

    setSelectedCaseMixSpecialityList(updated);
    setFilterOptions(prev => ({
      ...prev,
      caseMixSpeciality: updated,
      selectAllCaseMixSpecality: false
    }));
  };

  const handleSelectAllCaseMix = (e) => {
    e.stopPropagation();
    const shouldSelectAll = !filterOptions.selectAllCaseMixSpecality;
    const updated = shouldSelectAll ? [...caseMixSpecialityList] : [];
    
    setSelectedCaseMixSpecialityList(updated);
    setFilterOptions(prev => ({
      ...prev,
      caseMixSpeciality: updated,
      selectAllCaseMixSpecality: shouldSelectAll
    }));
  };

  // Insurer Identifier handlers
  const handleInsurerItemClick = (option, e) => {
    e.stopPropagation();
    const updated = selectedInsurerIdentifierList.includes(option)
      ? selectedInsurerIdentifierList.filter(item => item !== option)
      : [...selectedInsurerIdentifierList, option];

    setSelectedInsurerIdentifierList(updated);
    setFilterOptions(prev => ({
      ...prev,
      insurerIdentifier: updated,
      selectAllInsurerIdentifier: false
    }));
  };

  const handleSelectAllInsurer = (e) => {
    e.stopPropagation();
    const shouldSelectAll = !filterOptions.selectAllInsurerIdentifier;
    const updated = shouldSelectAll ? [...insurerIdentifierList] : [];
    
    setSelectedInsurerIdentifierList(updated);
    setFilterOptions(prev => ({
      ...prev,
      insurerIdentifier: updated,
      selectAllInsurerIdentifier: shouldSelectAll
    }));
  };

  // Coded By handlers
  const handleCodedByItemClick = (option, e) => {
    e.stopPropagation();
    const updated = selectedCodedByList.includes(option)
      ? selectedCodedByList.filter(item => item !== option)
      : [...selectedCodedByList, option];

    setSelectedCodedByList(updated);
    setFilterOptions(prev => ({
      ...prev,
      codedBy: updated,
      selectAllCodedBy: false
    }));
  };

  const handleSelectAllCodedBy = (e) => {
    e.stopPropagation();
    const shouldSelectAll = !filterOptions.selectAllCodedBy;
    const updated = shouldSelectAll ? [...codedByList] : [];
    
    setSelectedCodedByList(updated);
    setFilterOptions(prev => ({
      ...prev,
      codedBy: updated,
      selectAllCodedBy: shouldSelectAll
    }));
  };

  // Data fetching functions
  const filterOptionsFetch = async (page, load_more) => {
    try {
      setIsDropDownOptionsLoading(true);
      const response = await getFiltersOptionsData(page);
      const data = response?.data || {};
      
      if (load_more) {
        setDropDownOptions((prev) => ({
          caseMixSpeciality: [...prev.caseMixSpeciality, ...data.case_mix_speciality],
          insurerIdentifier: [...prev.insurerIdentifier, ...data.insurer_identifier],
          codedBy: [...prev.codedBy, ...data.coder_name],
          priorityValue: prev.priorityValue,
        }));
      } else {
        setDropDownOptions({
          caseMixSpeciality: data.case_mix_speciality || [],
          insurerIdentifier: data.insurer_identifier || [],
          codedBy: data.coder_name || [],
          priorityValue: [1, 2, 3, 4, 5],
        });
      }
      
      setHasMoreOptions(data.case_mix_speciality.length > 0 || data.insurer_identifier.length > 0);
      setCurrentPage((prev) => prev + 1);
    } catch (error) {
      console.error("Error fetching filter options:", error);
      setHasMoreOptions(false);
    } finally {
      setIsDropDownOptionsLoading(false);
    }
  };

  const fetchOptionsData = async (dropdownName, page, load_more) => {
    try {
      setIsLoading(true);
      const response = await getFiltersOptionsData(dropdownName, page);
      
      if (load_more) {
        if (dropdownName === "case_mix_speciality") {
          setCaseMixSpecialityList((prev) => [...prev, ...response?.data.case_mix_speciality]);
        } else if (dropdownName === "insurer_identifier") {
          setInsurerIdentifierList((prev) => [...prev, ...response?.data.insurer_identifier]);
        } else {
          setcodedByList((prev) => [...prev, ...response?.data.coded_by]);
        }
      } else {
        if (dropdownName === "case_mix_speciality") {
          setCaseMixSpecialityList([...response?.data.case_mix_speciality]);
        } else if (dropdownName === "insurer_identifier") {
          setInsurerIdentifierList([...response?.data.insurer_identifier]);
        } else {
          setcodedByList([...response?.data.coded_by]);
        }
      }
      setHasMany(true);
      setCurrentPage(page + 1);
    } catch (error) {
      console.log("Error fetching audit files:", error);
      setHasMany(false);
    } finally {
      setIsLoading(false);
    }
  };

  // Effect hooks
  useEffect(() => {
    if (filterOptions.selectAllCaseMixSpecality) {
      setSelectedCaseMixSpecialityList([...caseMixSpecialityList]);
    }
  }, [caseMixSpecialityList, filterOptions.selectAllCaseMixSpecality]);

  useEffect(() => {
    if (filterOptions.selectAllInsurerIdentifier) {
      setSelectedInsurerIdentifierList([...insurerIdentifierList]);
    }
  }, [insurerIdentifierList, filterOptions.selectAllInsurerIdentifier]);

  useEffect(() => {
    if (filterOptions.selectAllCodedBy) {
      setSelectedCodedByList([...codedByList]);
    }
  }, [codedByList, filterOptions.selectAllCodedBy]);
  // Priority values 
  const handleSelectAllPriority = (e)=>{
    // console.log(e.target.checked)
    const shouldSelectAll = !filterOptions.selectAllPriority;
    const updated = shouldSelectAll?[...priorityValues]:[]
    setFilterOptions((prev)=>({
      ...prev,
      priorityValue:updated,
      selectAllPriority:shouldSelectAll
    }))
    }
    
    
  
  const handlePriorityItemClick = (option, e) => {
    e.stopPropagation();
    const updated = filterOptions.priorityValue.includes(option)
      ? filterOptions.priorityValue.filter(item => item !== option)
      : [...filterOptions.priorityValue, option];

    // setFilterOptions(updated);
    setFilterOptions(prev => ({
      ...prev,
      priorityValue: updated,
      selectAllPriority: false
    }));
  };
   // Handle input change 
   const handleLengthOfStayChange = (e) => {
    const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    setLengthOfStayInput(input);
  };

  // Handle Enter key press
  const handleLengthOfStayKeyDown = (e) => {
    if (e.key === 'Enter' && lengthOfStayInput.trim() !== '') {
      // Add to filterOptions if not already present
      
        setFilterOptions(prev => ({
          ...prev,
          lengthOfStay: [...(prev.lengthOfStay || []), lengthOfStayInput]
        }));
      
      setLengthOfStayInput("");
    }
  };

  // Remove a length of stay value
  const removeLengthOfStay = (id) => {
    setFilterOptions(prev => ({
      ...prev,
      lengthOfStay: prev.lengthOfStay?.filter((item,index)=>index!==id) || []
    }));
  };


  return (
<>
  <div className="fmc-container">
    <div className="fmc-header">Filters</div>
    <div className="fmc-dropdowns-container">
      {/* Case Mix Speciality Dropdown */}
      <Dropdown className="fmc-dropdown" onToggle={(isOpen) => isOpen && fetchOptionsData("case_mix_speciality", 1, false)}>
        <Dropdown.Toggle className="fmc-dropdown-toggle">
          <CiWavePulse1 className="fmc-dropdown-icon" />
          Case Mix Speciality
        </Dropdown.Toggle>
        <Dropdown.Menu className="fmc-dropdown-menu">
          <InfiniteScroll
            className="fmc-dropdown-scroll"
            hasData={hasMany}
            loadMore={() => fetchOptionsData("case_mix_speciality", currentPage, true)}
            isLoading={isLoading}
          >
            <Dropdown.Item 
              as="div"
              className="fmc-dropdown-item fmc-select-all"
              onClick={(e) => handleSelectAllCaseMix(e)}
            >
              <Form.Check
                className="fmc-checkbox"
                type="checkbox"
                label="Select All"
                checked={filterOptions.selectAllCaseMixSpecality}
                onChange={(e) => handleSelectAllCaseMix(e)}
              />
            </Dropdown.Item>
            {caseMixSpecialityList.map((option, index) => (
              <Dropdown.Item 
                key={index} 
                as="div"
                className="fmc-dropdown-item"
                onClick={(e) => handleCaseMixItemClick(option, e)}
              >
                <Form.Check
                  className="fmc-checkbox"
                  type="checkbox"
                  label={option}
                  checked={selectedCaseMixSpecialityList.includes(option)}
                  onChange={(e) => handleCaseMixItemClick(option, e)}
                />
              </Dropdown.Item>
            ))}
          </InfiniteScroll>
        </Dropdown.Menu>
      </Dropdown>

      {/* Insurer Identifier Dropdown */}
      <Dropdown className="fmc-dropdown" onToggle={(isOpen) => isOpen && fetchOptionsData("insurer_identifier", 1, false)}>
        <Dropdown.Toggle className="fmc-dropdown-toggle">
          <GoFile className="fmc-dropdown-icon" />
          Insurer Identifier
        </Dropdown.Toggle>
        <Dropdown.Menu className="fmc-dropdown-menu">
          <InfiniteScroll
            className="fmc-dropdown-scroll"
            hasData={hasMany}
            loadMore={() => fetchOptionsData("insurer_identifier", currentPage, true)}
            isLoading={isLoading}
          >
            <Dropdown.Item 
              as="div"
              className="fmc-dropdown-item fmc-select-all"
              onClick={(e) => handleSelectAllInsurer(e)}
            >
              <Form.Check
                className="fmc-checkbox"
                type="checkbox"
                label="Select All"
                checked={filterOptions.selectAllInsurerIdentifier}
                onChange={(e) => handleSelectAllInsurer(e)}
              />
            </Dropdown.Item>
            {insurerIdentifierList.map((option) => (
              <Dropdown.Item 
                key={option} 
                as="div"
                className="fmc-dropdown-item"
                onClick={(e) => handleInsurerItemClick(option, e)}
              >
                <Form.Check
                  className="fmc-checkbox"
                  type="checkbox"
                  label={option}
                  checked={selectedInsurerIdentifierList.includes(option)}
                  onChange={(e) => handleInsurerItemClick(option, e)}
                />
              </Dropdown.Item>
            ))}
          </InfiniteScroll>
        </Dropdown.Menu>
      </Dropdown>

      {/* Coded By Dropdown */}
      <Dropdown className="fmc-dropdown" onToggle={(isOpen) => isOpen && fetchOptionsData("coded_by", 1, false)}>
        <Dropdown.Toggle className="fmc-dropdown-toggle">
          <GoPerson className="fmc-dropdown-icon" />
          Coded By
        </Dropdown.Toggle>
        <Dropdown.Menu className="fmc-dropdown-menu">
          <InfiniteScroll
            className="fmc-dropdown-scroll"
            hasData={hasMany}
            loadMore={() => fetchOptionsData("coded_by", currentPage, true)}
            isLoading={isLoading}
          >
            <Dropdown.Item 
              as="div"
              className="fmc-dropdown-item fmc-select-all"
              onClick={(e) => handleSelectAllCodedBy(e)}
            >
              <Form.Check
                className="fmc-checkbox"
                type="checkbox"
                label="Select All"
                checked={filterOptions.selectAllCodedBy}
                onChange={(e) => handleSelectAllCodedBy(e)}
              />
            </Dropdown.Item>
            {codedByList.map((option, index) => (
              <Dropdown.Item 
                key={index} 
                as="div"
                className="fmc-dropdown-item"
                onClick={(e) => handleCodedByItemClick(option, e)}
              >
                <Form.Check
                  className="fmc-checkbox"
                  type="checkbox"
                  label={option}
                  checked={selectedCodedByList.includes(option)}
                  onChange={(e) => handleCodedByItemClick(option, e)}
                />
              </Dropdown.Item>
            ))}
          </InfiniteScroll>
        </Dropdown.Menu>
      </Dropdown>

      {/* Priority Value Dropdown */}
      <Dropdown className="fmc-dropdown">
        <Dropdown.Toggle className="fmc-dropdown-toggle">
          <IoWarningOutline className="fmc-dropdown-icon" />
          Priority Value
        </Dropdown.Toggle>
        <Dropdown.Menu className="fmc-priority-dropdown-menu">
          <Dropdown.Item 
            as="div"
            className="fmc-dropdown-item fmc-select-all"
            onClick={(e) =>{ e.stopPropagation(e); handleSelectAllPriority(e)}}
          >
            <Form.Check
              className="fmc-checkbox"
              type="checkbox"
              label="Select All"
              checked={filterOptions.selectAllPriority}
              onChange={(e) =>{ e.stopPropagation(e);  handleSelectAllPriority(e)}}
            />
          </Dropdown.Item>
          {priorityValues.map((option) => (
            <Dropdown.Item 
              key={option} 
              as="div"
              className="fmc-dropdown-item"
              onClick={(e) =>{e.stopPropagation(e);  handlePriorityItemClick(option,e)}}
            >
              <Form.Check
                className="fmc-checkbox"
                type="checkbox"
                label={option}
                checked={filterOptions.priorityValue?.includes(option)}
                onChange={(e) =>{e.stopPropagation(e);  handlePriorityItemClick(option,e)}}
              />
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  </div>
</>
  );

}
export default FilterModal;